import { render, staticRenderFns } from "./PerfilFamiliaView.vue?vue&type=template&id=c3247b88"
import script from "./PerfilFamiliaView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilFamiliaView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports